import angular from 'angular';

const queryStringPath = /* @ngInject */ $translate => path => {
	let returnValue = '';
	if (Array.isArray(path)) {
		returnValue = path.map((item, k) => {
			// @ts-ignore
			let { name } = item;
			const { flow, kid } = item;
			let separator = ' ▶ ';

			if (kid === 'PATH_REL') {
				name = $translate.instant('query.relative-to-current-element');
			}

			if ('linker_info' in item) {
				// @ts-ignore
				// eslint-disable-next-line unicorn/consistent-destructuring
				name += ` :: ${item.linker_info.name}`;
			}

			if (k > 0) {
				if (flow === 'up') {
					separator = ' ◀ ';
				}
				name = separator + name;
			}

			return name;
		}).join('');
	}
	return returnValue;
};

/**
 * @ngdoc filter
 * @name app.filter:query/queryStrPath
 * @function
 * @description
 * # query/queryStrPath
 * Filter in the app.
 */
// eslint-disable-next-line angular/function-type
angular.module('app')
	.filter('queryStrPath', /* @ngInject */ queryStringPath);
